import { NgModule } from '@angular/core';
import { SortablejsModule } from 'angular-sortablejs/dist';
import { SchedulingComponent } from './scheduling.component';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingModule } from 'ngx-loading';
import { MatSelectModule, MatSliderModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FullCalendarModule } from 'ng-fullcalendar';
import { SchedulingTabComponent } from './scheduling-tab/scheduling-tab.component';
import { SchedulingCardComponent } from './scheduling-tab/scheduling-card/scheduling-card.component';
import { BrowserModule } from '@angular/platform-browser';
import { SchedulingPlcUpdateDialogComponent } from './scheduling-tab/scheduling-plc-update-dialog/scheduling-plc-update-dialog.component';
import { SchedulingSchedulesDialogComponent } from './scheduling-tab/scheduling-schedules-dialog/scheduling-schedules-dialog.component';
import { ScheduleCreateComponent } from './schedule-create/schedule-create.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SchedulingCreateDialogComponent } from './scheduling-device/scheduling-create-dialog/scheduling-create-dialog.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from 'ng-pick-datetime';
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    SortablejsModule,
    LoadingModule,
    MatSliderModule,
    FullCalendarModule,
    FormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatTooltipModule
  ],
  declarations: [
    SchedulingComponent,
    ScheduleCreateComponent,
    SchedulingCreateDialogComponent,
    SchedulingTabComponent,
    SchedulingCardComponent,
    SchedulingPlcUpdateDialogComponent,
    SchedulingSchedulesDialogComponent,
  ],
  exports: [
    ScheduleCreateComponent
  ]
})
export class SchedulingModule { }



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling.module.ts